/**
 * Localization form (country / language selector).
 *
 * The previous version queried the DOM and attached listeners from the constructor, with no
 * connectedCallback and no cleanup. A custom element's constructor can run before its children
 * exist - which is what happens when the Theme Editor re-renders the footer section - so the
 * selector could come back inert with no error in the console. Listeners were also bound with
 * .bind(this) and never removed, so a disconnect/reconnect doubled them.
 */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.onItemClick = this.onItemClick.bind(this);
    this.items = [];
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
    this.form = this.querySelector('form');

    this.items = Array.from(this.querySelectorAll('a'));
    this.items.forEach((item) => item.addEventListener('click', this.onItemClick));
  }

  disconnectedCallback() {
    this.items.forEach((item) => item.removeEventListener('click', this.onItemClick));
    this.items = [];
  }

  onItemClick(event) {
    if (!this.input || !this.form) return;

    event.preventDefault();
    this.input.value = event.currentTarget.dataset.value;
    this.form.submit();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
